export default __webpack_public_path__ + "static/2-browser-support-ce090cdd914a6d911f5a757786252a3d.png";